import { FunctionComponent, SVGProps } from 'react';
import Store from '../../assets/icons/Store.svg?react';
import Payments from '../../assets/icons/Payments.svg?react';
import Builder from '../../assets/icons/Builder.svg?react';
import Customer from '../../assets/icons/Customer.svg?react';
import Products from '../../assets/icons/Products.svg?react';
import Dashboard from '../../assets/icons/Dashboard.svg?react';
import Settings from '../../assets/icons/Settings.svg?react';
import Reports from '../../assets/icons/Reports.svg?react';
import Receipt from '../../assets/icons/Receipt.svg?react';
import DropDownIcon from '../../assets/icons/DropDownIcon.svg?react';
import User from '../../assets/icons/User.svg?react';
import NotePadEdit from '../../assets/icons/NotepadEdit.svg?react';
import Home from '../../assets/icons/Home.svg?react';
import Roles from '../../assets/icons/Roles.svg?react';
import Taxes from '../../assets/icons/Taxes.svg?react';
import Finances from '../../assets/icons/Finances.svg?react';
import NoteLine from '../../assets/icons/Notes-lines-alt.svg?react';
import Chart from '../../assets/icons/Chart_Mixed.svg?react';
import Wallet from '../../assets/icons/Wallet.svg?react';
import Education from '../../assets/icons/Education.svg?react';
import Logout from '../../assets/icons/LogOut.svg?react';
import ArrowDown from '../../assets/icons/ArrowDown.svg?react';
import Switch from '../../assets/icons/Switch.svg?react';
import Facebook from '../../assets/icons/Facebook.svg?react';
import Google from '../../assets/icons/Google.svg?react';
import Apple from '../../assets/icons/Apple.svg?react';
import Plus from '../../assets/icons/PlusOutline.svg?react';
import Close from '../../assets/icons/Close.svg?react';
import EyeInvisible from '../../assets/icons/Eye-invisible.svg?react';
import Trash from '../../assets/icons/Trash.svg?react';
import Copy from '../../assets/icons/Copy.svg?react';
import Share from '../../assets/icons/Share.svg?react';
import Sort from '../../assets/icons/Sort.svg?react';
import AppStore from '../../assets/icons/AppStore.svg?react';
import GlobalBlocks from '../../assets/icons/GlobalBlocks.svg?react';
import PrintBlocks from '../../assets/icons/PrintBlocks.svg?react';
import CustomerDisplay from '../../assets/icons/CustomerDisplay.svg?react';
import Media from '../../assets/icons/Media.svg?react';
import EyeVisible from '../../assets/icons/Eye-visible.svg?react';
import Heart from '../../assets/icons/Heart.svg?react';
import Tshirt from '../../assets/icons/Tshirt.svg?react';
import Pizza from '../../assets/icons/Pizza.svg?react';
import Coin from '../../assets/icons/CoinCircle.svg?react';
import Developer from '../../assets/icons/Developer.svg?react';
import Basket from '../../assets/icons/Basket.svg?react';
import House from '../../assets/icons/House.svg?react';
import Store2 from '../../assets/icons/Store2.svg?react';
import Seeding from '../../assets/icons/Seeding.svg?react';
import Tree from '../../assets/icons/Tree.svg?react';
import Houses from '../../assets/icons/Houses.svg?react';
import Trees from '../../assets/icons/Trees.svg?react';
import Stars from '../../assets/icons/Stars.svg?react';
import Exchange from '../../assets/icons/Exchange.svg?react';
import Info2 from '../../assets/icons/info2.svg?react';
import CheckBox from '../../assets/icons/CheckBox.svg?react';
import CoinDollar from '../../assets/icons/Coin.svg?react';
import SquareShare from '../../assets/icons/SquareShare.svg?react';
import More from '../../assets/icons/More.svg?react';
import Logo from '../../assets/icons/Logo.svg?react';
import FormSquare from '../../assets/icons/FromSquare.svg?react';
import RoundFormSquare from '../../assets/icons/RoundFormSquare.svg?react';
import CloudUpload from '../../assets/icons/CloudUpload.svg?react';
import IsClip from '../../assets/icons/IsClip.svg?react';
import Search from '../../assets/icons/Search.svg?react';
import Warehouse from '../../assets/icons/Warehouse.svg?react';
import Menu from '../../assets/icons/Menu.svg?react';
import Terminal from '../../assets/icons/Terminal.svg?react';
import PaperClip from '../../assets/icons/PaperClip.svg?react';
import Clock from '../../assets/icons/Clock.svg?react';
import Calendar from '../../assets/icons/Calendar.svg?react';
import Filter from '../../assets/icons/Filter.svg?react';
import Time from '../../assets/icons/Time.svg?react';
import Glass from '../../assets/icons/Glass.svg?react';
import CSV from '../../assets/icons/CSV.svg?react';
import Trash2 from '../../assets/icons/Trash2.svg?react';
import TrashCross from '../../assets/icons/TrashCross.svg?react';
import FilterArrow from '../../assets/icons/FilterArrow.svg?react';
import Superman from '../../assets/icons/Superman.svg?react';
import Bag from '../../assets/icons/Bag.svg?react';
import Book from '../../assets/icons/Book.svg?react';
import Building from '../../assets/icons/Building.svg?react';
import Rocket from '../../assets/icons/Rocket.svg?react';
import Bug from '../../assets/icons/Bug.svg?react';
import ArrowsSplitAlt from '../../assets/icons/ArrowsSplitAlt.svg?react';
import Discount from '../../assets/icons/Discount.svg?react';
import Refund from '../../assets/icons/Refund.svg?react';
import FinalLogo from '../../assets/icons/FinalLogo.svg?react';
import Woo from '../../assets/icons/Woo.svg?react';
import Box from '../../assets/icons/Box.svg?react';
import Customers from '../../assets/icons/Customers.svg?react';
import BillPayment from '../../assets/icons/BillPayment.svg?react';
import GooglePlayBtn from '../../assets/icons/GooglePlayBtn.svg?react';
import AppStoreBtn from '../../assets/icons/AppStoreBtn.svg?react';
import Attributes from '../../assets/icons/Attributes.svg?react';
import Categories from '../../assets/icons/Categories.svg?react';
import Chain from '../../assets/icons/Chain.svg?react';
import Final from '../../assets/icons/Final.svg?react';
import Vendara from '../../assets/icons/Vendara.svg?react';
import CheckTick from '../../assets/icons/CheckTick.svg?react';
import Hamburger from '../../assets/icons/Hamburger.svg?react';
import Options from '../../assets/icons/Options.svg?react';
import BackBtn from '../../assets/icons/BackBtn.svg?react';
import CartBag from '../../assets/icons/CartBag.svg?react';
import MyIntegrations from '../../assets/icons/MyIntegrations.svg?react';
import Lock from '../../assets/icons/Lock.svg?react';
import Question from '../../assets/icons/Question.svg?react';
import Line from '../../assets/icons/Line.svg?react';
import LineActive from '../../assets/icons/LineActive.svg?react';
import FinalBigLogo from '../../assets/icons/FinalBigLogo.svg?react';
import Infinity from '../../assets/icons/Infinity.svg?react';
import DoubleArrow from '../../assets/icons/DoubleArrow.svg?react';
import ArrowThin from '../../assets/icons/ArrowThin.svg?react';
import Link from '../../assets/icons/Link.svg?react';
import PoweredByStripe from '../../assets/icons/PoweredByStripe.svg?react';
import ChatDollar from '../../assets/icons/ChatDollar.svg?react';
import StartUp from '../../assets/icons/StartUp.svg?react';
import VendaraLogoHorizontal from '../../assets/icons/VendaraLogoHorizontal.svg?react';
import Mastercard from '../../assets/icons/Mastercard.svg?react';
import Visa from '../../assets/icons/Visa.svg?react';
import CircleCheck from '../../assets/icons/CircleCheck.svg?react';
import CircleXmark from '../../assets/icons/CircleXmark.svg?react';
import CircleCross from '../../assets/icons/CircleCross.svg?react';
import Alert from '../../assets/icons/Alert.svg?react';
import ArrowLeftLong from '../../assets/icons/ArrowLeftLong.svg?react';
import StockManagement from '../../assets/icons/StockManagement.svg?react';
import ArrowsSplit from '../../assets/icons/ArrowsSplit.svg?react';
import TrashCrossRed from '../../assets/icons/TrashCross.svg?react';
import BlueFinal from '../../assets/icons/BlueFinal.svg?react';
import Compass from '../../assets/icons/Compass.svg?react';
import ScaleLogo from '../../assets/icons/ScaleLogo.svg?react';
import Dots from '../../assets/icons/Dots.svg?react';
import LaunchLearn from '../../assets/icons/LaunchLearn.svg?react';
import LaunchPay from '../../assets/icons/LaunchPay.svg?react';
import LaunchScale from '../../assets/icons/LaunchScale.svg?react';
import LaunchBuild from '../../assets/icons/LaunchBuild.svg?react';
import LaunchManage from '../../assets/icons/LaunchManage.svg?react';
import LaunchRun from '../../assets/icons/LaunchRun.svg?react';
import LauncherLogout from '../../assets/icons/LauncherLogout.svg?react';
import PlusBlue from '../../assets/icons/PlusBlue.svg?react';
import BabyCheckmark from '../../assets/icons/BabyCheckmark.svg?react';
import Device from '../../assets/icons/Device.svg?react';
import Pencil_Edit from '../../assets/icons/Pencil_Edit.svg?react';
import Language from '../../assets/icons/Language.svg?react';
import SupportedOS from '../../assets/icons/SupportedOS.svg?react';
import MapPin from '../../assets/icons/MapPin.svg?react';
import ExchangeDollar from '../../assets/icons/ExchangeDollar.svg?react';
import SortBy from '../../assets/icons/SortBy.svg?react';
import Ruby from '../../assets/icons/Ruby.svg?react';
import BuilderLogo from '../../assets/icons/BuilderLogo.svg?react';
import LaunchGreyBackground from '../../assets/icons/LaunchGreyBackground.svg?react';
import PhoneCall from '../../assets/icons/phone_call.svg?react';
import Line5 from '../../assets/icons/Line5.svg?react';
import CodeLogo from '../../assets/icons/CodeLogo.svg?react';
import LaunchCode from '../../assets/icons/LaunchCode.svg?react';

export enum IconType {
  Store = 'Store',
  Payments = 'Payments',
  Builder = 'Builder',
  Customer = 'Customer',
  Products = 'Products',
  Dashboard = 'Dashboard',
  Settings = 'Settings',
  Reports = 'Reports',
  Receipt = 'Receipt',
  DropDownIcon = 'DropDownIcon',
  User = 'User',
  NotePadEdit = 'NotepadEdit',
  Home = 'Home',
  Roles = 'Roles',
  Taxes = 'Taxes',
  Finances = 'Finances',
  NoteLine = 'Notes-lines-alt',
  Chart = 'Chart_Mixed',
  Wallet = 'Wallet',
  Education = 'Education',
  Logout = 'LogOut',
  ArrowDown = 'ArrowDown',
  Switch = 'Switch',
  Facebook = 'Facebook',
  Google = 'Google',
  Apple = 'Apple',
  Plus = 'PlusOutline',
  Close = 'Close',
  EyeInvisible = 'Eye-invisible',
  Trash = 'Trash',
  Copy = 'Copy',
  Share = 'Share',
  Sort = 'Sort',
  AppStore = 'AppStore',
  GlobalBlocks = 'GlobalBlocks',
  PrintBlocks = 'PrintBlocks',
  CustomerDisplay = 'CustomerDisplay',
  Media = 'Media',
  EyeVisible = 'Eye-visible',
  Heart = 'Heart',
  Tshirt = 'Tshirt',
  Pizza = 'Pizza',
  Coin = 'CoinCircle',
  Developer = 'Developer',
  Basket = 'Basket',
  House = 'House',
  Store2 = 'Store2',
  Seeding = 'Seeding',
  Tree = 'Tree',
  Houses = 'Houses',
  Trees = 'Trees',
  Stars = 'Stars',
  Exchange = 'Exchange',
  Info2 = 'info2',
  CheckBox = 'CheckBox',
  CoinDollar = 'Coin',
  SquareShare = 'SquareShare',
  More = 'More',
  Logo = 'Logo',
  FormSquare = 'FromSquare',
  RoundFormSquare = 'RoundFormSquare',
  CloudUpload = 'CloudUpload',
  IsClip = 'IsClip',
  Search = 'Search',
  Warehouse = 'Warehouse',
  Menu = 'Menu',
  Terminal = 'Terminal',
  PaperClip = 'PaperClip',
  Clock = 'Clock',
  Calendar = 'Calendar',
  Filter = 'Filter',
  Time = 'Time',
  Glass = 'Glass',
  CSV = 'CSV',
  Trash2 = 'Trash2',
  TrashCross = 'TrashCross',
  FilterArrow = 'FilterArrow',
  Superman = 'Superman',
  Bag = 'Bag',
  Book = 'Book',
  Building = 'Building',
  Rocket = 'Rocket',
  Bug = 'Bug',
  ArrowsSplitAlt = 'ArrowsSplitAlt',
  Discount = 'Discount',
  Refund = 'Refund',
  FinalLogo = 'FinalLogo',
  Woo = 'Woo',
  Box = 'Box',
  Customers = 'Customers',
  BillPayment = 'BillPayment',
  GooglePlayBtn = 'GooglePlayBtn',
  AppStoreBtn = 'AppStoreBtn',
  Attributes = 'Attributes',
  Categories = 'Categories',
  Chain = 'Chain',
  Final = 'Final',
  Vendara = 'Vendara',
  CheckTick = 'CheckTick',
  Hamburger = 'Hamburger',
  Options = 'Options',
  BackBtn = 'BackBtn',
  CartBag = 'CartBag',
  MyIntegrations = 'MyIntegrations',
  Lock = 'Lock',
  Question = 'Question',
  Line = 'Line',
  LineActive = 'LineActive',
  FinalBigLogo = 'FinalBigLogo',
  Infinity = 'Infinity',
  DoubleArrow = 'DoubleArrow',
  ArrowThin = 'ArrowThin',
  Link = 'Link',
  PoweredByStripe = 'PoweredByStripe',
  ChatDollar = 'ChatDollar',
  StartUp = 'StartUp',
  VendaraLogoHorizontal = 'VendaraLogoHorizontal',
  Mastercard = 'Mastercard',
  Visa = 'Visa',
  CircleCheck = 'CircleCheck',
  CircleXmark = 'CircleXmark',
  CircleCross = 'CircleCross',
  Alert = 'Alert',
  ArrowLeftLong = 'ArrowLeftLong',
  StockManagement = 'StockManagement',
  ArrowsSplit = 'ArrowsSplit',
  TrashCrossRed = 'TrashCrossRed',
  BlueFinal = 'BlueFinal',
  Compass = 'Compass',
  ScaleLogo = 'ScaleLogo',
  Dots = 'Dots',
  LaunchLearn = 'LaunchLearn',
  LaunchPay = 'LaunchPay',
  LaunchScale = 'LaunchScale',
  LaunchBuild = 'LaunchBuild',
  LaunchManage = 'LaunchManage',
  LaunchRun = 'LaunchRun',
  LauncherLogout = 'LauncherLogout',
  PlusBlue = 'PlusBlue',
  BabyCheckmark = 'BabyCheckmark',
  Device = 'Device',
  Pencil_Edit = 'Pencil_Edit',
  Language = 'Language',
  SupportedOS = 'SupportedOS',
  MapPin = 'MapPin',
  ExchangeDollar = 'ExchangeDollar',
  SortBy = 'SortBy',
  Ruby = 'Ruby',
  BuilderLogo = 'BuilderLogo',
  LaunchGreyBackground = 'LaunchGreyBackground',
  PhoneCall = 'PhoneCall',
  Line5 = 'Line5',
  CodeLogo = 'CodeLogo',
  LaunchCode = 'LaunchCode',
}

const icons: Record<IconType, FunctionComponent<SVGProps<SVGSVGElement>>> = {
  [IconType.Store]: Store,
  [IconType.Payments]: Payments,
  [IconType.Builder]: Builder,
  [IconType.Customer]: Customer,
  [IconType.Products]: Products,
  [IconType.Dashboard]: Dashboard,
  [IconType.Settings]: Settings,
  [IconType.Reports]: Reports,
  [IconType.Receipt]: Receipt,
  [IconType.DropDownIcon]: DropDownIcon,
  [IconType.User]: User,
  [IconType.NotePadEdit]: NotePadEdit,
  [IconType.Home]: Home,
  [IconType.Roles]: Roles,
  [IconType.Taxes]: Taxes,
  [IconType.Finances]: Finances,
  [IconType.NoteLine]: NoteLine,
  [IconType.Chart]: Chart,
  [IconType.Wallet]: Wallet,
  [IconType.Education]: Education,
  [IconType.Logout]: Logout,
  [IconType.ArrowDown]: ArrowDown,
  [IconType.Switch]: Switch,
  [IconType.Facebook]: Facebook,
  [IconType.Google]: Google,
  [IconType.Apple]: Apple,
  [IconType.Plus]: Plus,
  [IconType.Close]: Close,
  [IconType.EyeInvisible]: EyeInvisible,
  [IconType.Trash]: Trash,
  [IconType.Copy]: Copy,
  [IconType.Share]: Share,
  [IconType.Sort]: Sort,
  [IconType.AppStore]: AppStore,
  [IconType.GlobalBlocks]: GlobalBlocks,
  [IconType.PrintBlocks]: PrintBlocks,
  [IconType.CustomerDisplay]: CustomerDisplay,
  [IconType.Media]: Media,
  [IconType.EyeVisible]: EyeVisible,
  [IconType.Heart]: Heart,
  [IconType.Tshirt]: Tshirt,
  [IconType.Pizza]: Pizza,
  [IconType.Coin]: Coin,
  [IconType.Developer]: Developer,
  [IconType.Basket]: Basket,
  [IconType.House]: House,
  [IconType.Store2]: Store2,
  [IconType.Seeding]: Seeding,
  [IconType.Tree]: Tree,
  [IconType.Houses]: Houses,
  [IconType.Trees]: Trees,
  [IconType.Stars]: Stars,
  [IconType.Exchange]: Exchange,
  [IconType.Info2]: Info2,
  [IconType.CheckBox]: CheckBox,
  [IconType.CoinDollar]: CoinDollar,
  [IconType.SquareShare]: SquareShare,
  [IconType.More]: More,
  [IconType.Logo]: Logo,
  [IconType.FormSquare]: FormSquare,
  [IconType.RoundFormSquare]: RoundFormSquare,
  [IconType.CloudUpload]: CloudUpload,
  [IconType.IsClip]: IsClip,
  [IconType.Search]: Search,
  [IconType.Warehouse]: Warehouse,
  [IconType.Menu]: Menu,
  [IconType.Terminal]: Terminal,
  [IconType.PaperClip]: PaperClip,
  [IconType.Clock]: Clock,
  [IconType.Calendar]: Calendar,
  [IconType.Filter]: Filter,
  [IconType.Time]: Time,
  [IconType.Glass]: Glass,
  [IconType.CSV]: CSV,
  [IconType.Trash2]: Trash2,
  [IconType.TrashCross]: TrashCross,
  [IconType.FilterArrow]: FilterArrow,
  [IconType.Superman]: Superman,
  [IconType.Bag]: Bag,
  [IconType.Book]: Book,
  [IconType.Building]: Building,
  [IconType.Rocket]: Rocket,
  [IconType.Bug]: Bug,
  [IconType.ArrowsSplitAlt]: ArrowsSplitAlt,
  [IconType.Discount]: Discount,
  [IconType.Refund]: Refund,
  [IconType.FinalLogo]: FinalLogo,
  [IconType.Woo]: Woo,
  [IconType.Box]: Box,
  [IconType.Customers]: Customers,
  [IconType.BillPayment]: BillPayment,
  [IconType.GooglePlayBtn]: GooglePlayBtn,
  [IconType.AppStoreBtn]: AppStoreBtn,
  [IconType.Attributes]: Attributes,
  [IconType.Categories]: Categories,
  [IconType.Chain]: Chain,
  [IconType.Final]: Final,
  [IconType.Vendara]: Vendara,
  [IconType.CheckTick]: CheckTick,
  [IconType.Hamburger]: Hamburger,
  [IconType.Options]: Options,
  [IconType.BackBtn]: BackBtn,
  [IconType.CartBag]: CartBag,
  [IconType.MyIntegrations]: MyIntegrations,
  [IconType.Lock]: Lock,
  [IconType.Question]: Question,
  [IconType.Line]: Line,
  [IconType.LineActive]: LineActive,
  [IconType.FinalBigLogo]: FinalBigLogo,
  [IconType.Infinity]: Infinity,
  [IconType.DoubleArrow]: DoubleArrow,
  [IconType.ArrowThin]: ArrowThin,
  [IconType.Link]: Link,
  [IconType.PoweredByStripe]: PoweredByStripe,
  [IconType.ChatDollar]: ChatDollar,
  [IconType.StartUp]: StartUp,
  [IconType.VendaraLogoHorizontal]: VendaraLogoHorizontal,
  [IconType.Mastercard]: Mastercard,
  [IconType.Visa]: Visa,
  [IconType.CircleCheck]: CircleCheck,
  [IconType.CircleXmark]: CircleXmark,
  [IconType.CircleCross]: CircleCross,
  [IconType.Alert]: Alert,
  [IconType.ArrowLeftLong]: ArrowLeftLong,
  [IconType.StockManagement]: StockManagement,
  [IconType.ArrowsSplit]: ArrowsSplit,
  [IconType.TrashCrossRed]: TrashCrossRed,
  [IconType.BlueFinal]: BlueFinal,
  [IconType.Compass]: Compass,
  [IconType.ScaleLogo]: ScaleLogo,
  [IconType.Dots]: Dots,
  [IconType.LaunchLearn]: LaunchLearn,
  [IconType.LaunchPay]: LaunchPay,
  [IconType.LaunchScale]: LaunchScale,
  [IconType.LaunchBuild]: LaunchBuild,
  [IconType.LaunchManage]: LaunchManage,
  [IconType.LaunchRun]: LaunchRun,
  [IconType.LauncherLogout]: LauncherLogout,
  [IconType.PlusBlue]: PlusBlue,
  [IconType.BabyCheckmark]: BabyCheckmark,
  [IconType.Device]: Device,
  [IconType.Pencil_Edit]: Pencil_Edit,
  [IconType.Language]: Language,
  [IconType.SupportedOS]: SupportedOS,
  [IconType.MapPin]: MapPin,
  [IconType.ExchangeDollar]: ExchangeDollar,
  [IconType.SortBy]: SortBy,
  [IconType.Ruby]: Ruby,
  [IconType.BuilderLogo]: BuilderLogo,
  [IconType.LaunchGreyBackground]: LaunchGreyBackground,
  [IconType.PhoneCall]: PhoneCall,
  [IconType.Line5]: Line5,
  [IconType.CodeLogo]: CodeLogo,
  [IconType.LaunchCode]: LaunchCode,
};

export default icons;
